import * as Yup from 'yup';

export const loginValidationSchema = Yup.object().shape({
  name: Yup.string().required('Name is required'),
  email: Yup.string().email('Invalid email').required('Email is required'),
  web3: Yup.string().required('Web-3 Address is required'),
  couponName: Yup.string().required('Coupon Name is required')
    .matches(/^[a-zA-Z0-9_]*$/, 'Space not allowed'),
  region: Yup.string().required("Please Select Your Country/Region"),
  confirmMail: Yup.string()
    .oneOf([Yup.ref('email'), null], 'Emails must match') 
    .email('Invalid Email')
    .required('Please Confirm Your Email'),
  // phoneNumber: Yup.string().required('Phone Number is required'),
  discord:
    Yup.string().url('Invalid URL').optional('Discord Address is required'),
  telegram:
    Yup.string().url('Invalid URL').optional('Telegram Address is required'),
  twitter:
    Yup.string().url('Invalid URL').optional('Twitter Address is required'),
  youtube:
    Yup.string().url('Invalid URL').optional('Youtube Account is required'),
  user_captcha_input: Yup.string().required('Captcha is required'), // Captcha validation

});

export const couponValidationSchema = Yup.object().shape({
  email: Yup.string().email('Invalid email').optional('Email is required'),
  telegramAddress:
    Yup.string().url('Invalid URL').optional('Discord Address is required'),

});

export const presaleValidationSchema = Yup.object().shape({

  investedamount: Yup.string().required('Invested Amount is required')
    .matches(/^(0|[1-9]\d*)(\.\d{1,18})?([eE][+-]?\d+)?$|^0\.\d{1,18}([eE][+-]?\d+)?$/, 'Invalid Amount')
    .test("less_than_100" , 'Invested Amount max 100 for one transaction' , value => {
      const num = parseFloat(value).toFixed(18);
      return !isNaN(num) && num <= 100;
    })
    .test("is_zero" , 'Invested Amount must be greater than 0' , value => {
      const num = parseFloat(value).toFixed(18);
      return !isNaN(num) && num != 0;
   
    })
    ,
  // returnamount: Yup.string().required('Return Amount is required')
  //   .matches(/^\d+(\.\d{1,18})?$/, 'Invalid Amount'),
  
});

// Defining the validation schema for a promoter form
export const promoterValidationSchema = Yup.object().shape({
  // 'name' field must be a string and is required
  name: Yup.string().required('Name is required'),

  // 'email' field must be a valid email format and is required
  email: Yup.string().email('Invalid email').required('Email is required'),

  // 'web3' field must be a string and is required
  web3: Yup.string().required('Web-3 Address is required'),

  // 'discord' field must be a valid URL format, but is optional
  discord: Yup.string().url('Invalid URL').optional(),

  // 'telegram' field must be a valid URL format, but is optional
  telegram: Yup.string().url('Invalid URL').optional(),

  // 'twitter' field must be a valid URL format, but is optional
  twitter: Yup.string().url('Invalid URL').optional(),

  // 'youtube' field must be a valid URL format, but is optional
  youtube: Yup.string().url('Invalid URL').optional(),

  user_captcha_input: Yup.string().required('Captcha is required'), // Captcha validation

  couponName: Yup.string().required('Coupon Name is required')
    .matches(/^[a-zA-Z0-9_]*$/, 'Space not allowed'),

  region: Yup.string().required("Please Select Your Country/Region"),
  confirmMail: Yup.string()
    .oneOf([Yup.ref('email'), null], 'Emails must match') 
    .email('Invalid Email')
    .required('Please Confirm Your Email'),

});
export const tier0ValidationSchema = Yup.object().shape({
  // 'name' field must be a string and is required
  name: Yup.string().required('Name is required'),

  // 'email' field must be a valid email format and is required
  email: Yup.string().email('Invalid email').required('Email is required'),


  user_captcha_input: Yup.string().required('Captcha is required'), // Captcha validation

  couponName: Yup.string().required('Coupon Name is required')
    .matches(/^[a-zA-Z0-9_]*$/, 'Space not allowed'),

  region: Yup.string().required("Please Select Your Country/Region"),
  confirmMail: Yup.string()
      .oneOf([Yup.ref('email'), null], 'Emails must match')
      .email('Invalid Email')
      .required('Please Confirm Your Email'),
  web3: Yup.string(),


});